const steps = [
  {
    icon: "ri-smartphone-line",
    step: "01",
    device: "手机通勤路上",
    text: "地铁上随手点开尾巴漫画网，翻到第 128 话第 12 页，书签自动落下。",
    tone: "bg-primary-100 text-primary-700",
  },
  {
    icon: "ri-tablet-line",
    step: "02",
    device: "平板睡前接着看",
    text: "换到平板登录同一账号，无需任何操作，直接落在刚才那页继续读。",
    tone: "bg-secondary-100 text-secondary-700",
  },
  {
    icon: "ri-computer-line",
    step: "03",
    device: "电脑大屏再刷",
    text: "书架、收藏、历史与足迹同步在线，任意设备打开都在最新进度。",
    tone: "bg-accent-100 text-accent-800",
  },
];

export default function Scenarios() {
  return (
    <section id="scenarios" className="py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-800">
              <i className="ri-device-line"></i>
              阅读场景
            </span>
            <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">
              同一部漫画，三个屏幕无缝接力
            </h2>
            <p className="mt-4 leading-relaxed text-foreground-700">
              不管你在哪台设备读到哪一章，尾巴漫画网都会把阅读进度牢牢记住并实时同步。
              通勤用手机刷几话、睡前换平板看、周末在大屏慢慢回味，断点续读从不打断你的沉浸。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              {["自动书签", "实时同步", "断点续读", "足迹归档"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-background-100 px-4 py-2 text-sm font-medium text-foreground-700"
                >
                  <i className="ri-check-line mr-1 text-secondary-600"></i>
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="relative rounded-2xl border border-background-200 bg-background-50 p-6 md:p-8">
            <div className="absolute -right-4 -top-4 flex h-20 w-20 items-center justify-center rounded-full bg-accent-500 text-2xl text-background-50">
              <i className="ri-refresh-line"></i>
            </div>
            <div className="space-y-5">
              {steps.map((item) => (
                <div
                  key={item.step}
                  className="flex items-start gap-4 rounded-xl bg-background-100/60 p-4"
                >
                  <div
                    className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl text-xl ${item.tone}`}
                  >
                    <i className={item.icon}></i>
                  </div>
                  <div className="min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="font-heading text-sm text-foreground-500">{item.step}</span>
                      <h3 className="font-heading text-lg text-foreground-950">{item.device}</h3>
                    </div>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-700">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}